//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from "vuedraggable";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import QAuModelPicker from "@/components/Generics/ModelPicker/qAuModelPicker.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQListBtn from "@/components/Generics/AQButtonsList/AQButtonsList.vue";
import { SETTINGS_BTNS } from "./AQDataTable.const";

/**
     * EVENTS :
     * "@orderColumnsChanged" => emit event with new columns order (and new columns from Data Model)
     * "@columnsOpenData" => emit event when popover opens or closes
     */

export default {
    name: "AQDataColumnSettings",
    components: {
        draggable,
        AQButton,
        AQCheckbox,
        QAuModelPicker,
        AQBadge,
        AQTooltip,
        AQListBtn
    },
    props: {
        atId: { type: String, default: "table" },
        iconBtn: { type: String, default: "settings" }, // set custom icon (button that trigger popover)
        infoTooltip: { type: String, default: "" }, // tooltip message for iconBtn
        columns: { type: Array, default: () => [] }, // (Required) Defining each table column’s properties.
        defaultColumns: { type: Array, default: () => [] }, // Defining list of columns used on default button action
        noAttributeLimit: { type: Boolean, default: false }, // show / hide limit for add items from data model
        attributesLimit: { type: Number, default: 20 }, // limit number of items from data model
        reorder: { type: Boolean, default: false }, // enable/disable reorder elements
        noDataModel: { type: Boolean, default: false }, // show / hide data model button
        dataModelMode: { type: String, default: "d" }, // mode for data model component
        forceModelUpdate: { type: Boolean, default: false }, // force update data model
        title: { type: String, default: "" }, // title of popover
        hideDefaultBtn: { type: Boolean, default: false }, // hide default button
        focusScrollEnd: { type: Boolean, default: false }, // focus scroll end when adding dms
        labelConfirmButton: { type: String, default: "" }, // custom label for confirmation button
        optTooltipMsg: { type: String, default: "" },
        keepOneSelected: { type: Boolean, default: false },
        removeDMOnReset: { type: Boolean, default: false },
        expandCatalogues: { type: Boolean, default: true },
        selectCatalogues: { type: Boolean, default: false }

    },
    data() {
        return {
            drag: false,
            settingsDisabled: true,
            selectedColumnSettings: [],
            dataModelNewColumns: [],
            settingsData: [],
            dataModelValues: [],
            remainingOptionsOnLoad: 0,
            tableColumns: [],
            showDataModel: false,
            dataModelHeight: "400px",
            settingsBtns: SETTINGS_BTNS,
            firstLoad: true,
            hideListBtn: ["edit", "more", "copy", "download"]
        };
    },
    computed: {
        remainingAttributesToSelect() {
            return `${this.achievedLimit ? this.attributesLimit : (this.dataModelNewColumns.length || this.remainingOptionsOnLoad)} / ${this.attributesLimit}`;
        },
        disableConfirm() {
            return (this.dataModelNewColumns.length || this.remainingOptionsOnLoad) > this.attributesLimit;
        },
        stopSelection() {
            return (this.dataModelNewColumns.length || this.remainingOptionsOnLoad) >= this.attributesLimit;
        },
        achievedLimit() {
            return (this.dataModelNewColumns.length === this.attributesLimit || this.disableConfirm);
        },
        checkOneSelectedOpt() {
            return this.keepOneSelected && this.selectedColumnSettings.length === 1;
        },
        getTooltipMsg() {
            return this.optTooltipMsg || this.$t("perspectiveBuilder.tabTable.oneColSelected");
        }
    },
    watch: {
        columns: {
            handler(newValue) {
                this.tableColumns = newValue || [];
            },
            immediate: true
        },
        hideDefaultBtn: {
            handler(value) {
                if (value) {
                    this.settingsBtns = this.settingsBtns.filter(elem => elem.type !== "reset");
                }
            },
            immediate: true
        }
    },
    methods: {
        openSettings() {
            if (this.settingsDisabled) {
                this.selectedColumnSettings = this.tableColumns.filter(elem => elem.visible || elem.required).map(elem => elem.name);
                this.settingsData = JSON.parse(JSON.stringify(this.tableColumns));
                this.settingsDisabled = false;
            } else {
                this.settingsDisabled = true;
                this.$refs.columnsPopoverRef.hide();
            }
        },
        openColumns() {
            this.$emit("columnsOpenData", true);
        },
        closeColumns() {
            this.settingsDisabled = true;
            this.showDataModel = false;
            this.$emit("columnsOpenData");
        },
        selectValue(response, item) {
            const columnIndex = this.settingsData.findIndex(elem => elem.name === item.name);
            if (columnIndex !== -1) {
                this.settingsData[columnIndex].visible = this.selectedColumnSettings.includes(item.name);
            }
        },
        deleteColumn(col, index) {
            if (!(this.checkOneSelectedOpt && this.selectedColumnSettings[0] === col.name)) {
                const checkToRemove = this.checkOneSelectedOpt ? !col.visible : true;
                if (checkToRemove) {
                    this.settingsData.splice(index, 1);
                    if (col.type) {
                        this.selectedColumnSettings = this.selectedColumnSettings.filter(elem => elem !== col.name);
                    }
                    const indexCol = this.dataModelNewColumns.findIndex(elem => elem.formatted === col.typeFormatted);
                    if (indexCol !== -1) {
                        this.dataModelNewColumns.splice(indexCol, 1);
                    }
                }
            }
        },
        triggerBtnAction(actionType) {
            switch (actionType) {
                case "confirm": {
                    this.tableColumns = JSON.parse(JSON.stringify(this.settingsData));
                    this.$refs.columnsPopoverRef.hide();
                    this.$emit("orderColumnsChanged", this.tableColumns);
                    break;
                }
                case "reset": {
                    const dataModelColumns = [];
                    if (!this.removeDMOnReset) {
                        const existingDefaultModel = this.defaultColumns.filter(({ dataType }) => (!!dataType)).map(({ name }) => (name));
                        this.settingsData.forEach(col => {
                            const colData = { ...col };
                            if (colData.dataModelType && !existingDefaultModel.includes(colData.name)) {
                                colData.visible = false;
                                dataModelColumns.push(colData);
                            }
                        });
                    }

                    const defCols = JSON.parse(JSON.stringify(this.defaultColumns));
                    this.settingsData = [...defCols, ...dataModelColumns];
                    this.selectedColumnSettings = this.settingsData.filter(elem => elem.visible || elem.required).map(elem => elem.name);
                    break;
                }
                case "dataModel": {
                    this.dataModelValues = this.settingsData.filter(elem => elem.dataModelType).map(item => item.field);
                    this.remainingOptionsOnLoad = this.dataModelValues.length;
                    this.setStyleDataModel();
                    this.showDataModel = true;
                    this.firstLoad = true;
                    break;
                }
                case "cancel": {
                    this.$refs.columnsPopoverRef.hide();
                    break;
                }
                default:
                    this.$refs.columnsPopoverRef.hide();
            }
        },
        setValueDataModel(action) {
            if (action === "confirm") {
                const newFormatColumns = this.dataModelNewColumns.filter(item => !this.dataModelValues.includes(item.key)).map(elem => {
                    this.selectedColumnSettings.push(elem.formatted);
                    const label = elem.key.split(".");
                    return {
                        type: elem.formatted.startsWith("m_") ? "MOD" : "VAR",
                        dataModelType: true,
                        dataType: elem.node.attrType,
                        typeFormatted: elem.formatted,
                        align: elem.node.attrType === "string" ? "left" : "right",
                        field: elem.key,
                        name: elem.formatted,
                        label: label.length > 2 ? `${label[label.length - 2]}.${label.pop()}` : elem.key,
                        sortable: false,
                        visible: true,
                        style: "width:1%"
                    };
                });

                if (this.dataModelValues && this.dataModelValues.length) {
                    const newColumnsMapped = this.dataModelNewColumns.map(elem => elem.key);
                    this.dataModelValues.forEach(item => {
                        if (!newColumnsMapped.includes(item)) {
                            this.settingsData = this.settingsData.filter(elem => {
                                let isExist = true;
                                if (elem.dataModelType && elem.field === item) {
                                    this.selectedColumnSettings = this.selectedColumnSettings.filter(checkElem => checkElem !== elem.name);
                                    isExist = false;
                                }
                                return isExist;
                            });
                        }
                    });
                }

                if (newFormatColumns && newFormatColumns.length) {
                    this.settingsData = [...this.settingsData, ...newFormatColumns];
                }
                if (this.keepOneSelected) {
                    const hasVisible = this.settingsData.find(elem => elem.visible);
                    if (!hasVisible) {
                        const [first, ...rest] = this.settingsData;
                        this.selectedColumnSettings.push(first.name);
                        first.visible = true;
                        this.settingsData = [first, ...rest];
                    }
                }
            }
            if (this.focusScrollEnd) {
                setTimeout(() => {
                    this.$refs.attributesRef.$el.scrollTop = this.dataModelNewColumns.length ? this.$refs.attributesRef.$el.scrollHeight : 0;
                    this.dataModelNewColumns = [];
                }, 0);
            } else {
                this.dataModelNewColumns = [];
            }
            this.showDataModel = false;
        },
        onModelSelect(data) {
            this.firstLoad = false;
            this.dataModelNewColumns = data;
            if (this.remainingOptionsOnLoad) {
                this.remainingOptionsOnLoad = 0;
            }
        },
        setStyleDataModel() {
            const { orderColumnsRef } = this.$refs;
            this.dataModelHeight = orderColumnsRef ? `${orderColumnsRef.clientHeight}px` : "400px";
        }
    }
};
